import { render, staticRenderFns } from "./indexWtxh.vue?vue&type=template&id=76ec6df5&scoped=true"
import script from "./indexWtxh.vue?vue&type=script&lang=js"
export * from "./indexWtxh.vue?vue&type=script&lang=js"
import style0 from "./indexWtxh.vue?vue&type=style&index=0&id=76ec6df5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76ec6df5",
  null
  
)

export default component.exports